import React, {useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
// Importation des logos
import logoLille from "./media/logo_univ_lille.webp";
import logoLilleWhite from "./media/logo_univ_lille_white.webp";
import logoMontpellier from "./media/logo_univ_montpellier.webp";
import "./Education.css";

function Education() {
  const { t, i18n } = useTranslation();
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    const handleThemeChange = () => setTheme(localStorage.getItem("theme") || "dark");
    window.addEventListener("themeChanged", handleThemeChange);
    return () => window.removeEventListener("themeChanged", handleThemeChange);
  }, []);

const education = [
  {
    title: t("edu_master_title"),
    period: "2023 — 2025",
    parcours: t("edu_master_parcours"),
    label: t("label_master"), // Utilise la clé Master
    location: t("edu_master_location"),
    logo: theme === "dark" ? logoLilleWhite : logoLille,
    alt: t("edu_lille_alt"),
    borderClass: "border-lille",
  },
  {
    title: t("edu_bachelor_title"),
    period: "2019 — 2023",
    parcours: t("edu_bachelor_parcours"),
    label: t("label_bachelor"), // Utilise la clé Bachelor
    location: t("edu_bachelor_location"),
    logo: logoMontpellier,
    alt: t("edu_montpellier_alt"),
    borderClass: "border-montpellier",
  },
];

  return (
<Container className="education-section" key={i18n.language}>
  <Row className="justify-content-center position-relative">
    
    {/* Conteneur principal de la liste */}
    <Col lg={11} className="position-relative">
      
      {/* LE RAIL (À gauche, hors des cartes) */}
      <div className="timeline-rail d-none d-lg-block"></div>

      {education.map((edu, index) => (
        <Row className="education-item-row mb-5" key={index}>
          
          {/* ZONE FRISE : Date + Point d'ancrage */}
          <Col lg={3} className="timeline-zone d-none d-lg-flex">
            <div className="timeline-date-wrapper">
              <span className="timeline-period-text">{edu.period}</span>
            </div>
            <div className="timeline-dot-container">
              <div className="timeline-dot"></div>
            </div>
          </Col>

          {/* ZONE CARTE : Le contenu */}
<Col xs={12} lg={9} className="education-card-container">
  <div className="education-card">
    {/* Conteneur de l'image : centré en haut sur mobile */}
    <div className="education-mobile-logo-section">
<div className={`education-logo-wrapper ${edu.borderClass}`}>
  <img src={edu.logo} alt={edu.alt} className="education-logo" />
</div>
    </div>

    {/* Séparateur horizontal discret (remplace le vertical) */}
    <div className="education-mobile-divider d-lg-none"></div>

    <div className="education-card-body">
      <div className="education-header">
        <h2 className="education-title">{edu.title}</h2>
{/* AJOUTE d-lg-none ICI pour qu'elle disparaisse sur grand écran */}
  <span className="education-period d-lg-none">{edu.period}</span>
        </div>

<div className="education-content">
  <p className="education-parcours">
    {/* On utilise ici l'étiquette spécifique à l'élément (Major ou Specialization) */}
    <span className="parcours-label-style">{edu.label}</span>
    <span className="education-separator">
      {i18n.language.startsWith("en") ? ": " : " : "}
    </span>
    {edu.parcours}
  </p>
</div>

      <div className="education-footer">
        <div className="education-location">
          <FaMapMarkerAlt className="location-icon" />
          <span>{edu.location}</span>
        </div>
      </div>
    </div>
  </div>
</Col>
        </Row>
      ))}
    </Col>
  </Row>
</Container>
  );
}

export default Education;